// Autogenerated file, DO NOT MODIFY or it will be overwritten;
import type { SVGProps } from 'react';

import { forwardRef } from '@chakra-ui/react';

import { Icon, type IconProps } from '../Icon';

const Svg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 20 16"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.75}
      d="M1.66602 3.83398L8.47011 8.59685C9.02109 8.98254 9.29658 9.17538 9.59624 9.25007C9.86093 9.31605 10.1378 9.31605 10.4025 9.25007C10.7021 9.17538 10.9776 8.98254 11.5286 8.59685L18.3327 3.83398M5.66602 14.6673H14.3327C15.7328 14.6673 16.4329 14.6673 16.9677 14.3948C17.4381 14.1552 17.8205 13.7727 18.0602 13.3023C18.3327 12.7675 18.3327 12.0674 18.3327 10.6673V5.33398C18.3327 3.93385 18.3327 3.23379 18.0602 2.69901C17.8205 2.2286 17.4381 1.84615 16.9677 1.60647C16.4329 1.33398 15.7328 1.33398 14.3327 1.33398H5.66602C4.26588 1.33398 3.56582 1.33398 3.03104 1.60647C2.56063 1.84615 2.17818 2.2286 1.9385 2.69901C1.66602 3.23379 1.66602 3.93385 1.66602 5.33398V10.6673C1.66602 12.0674 1.66602 12.7675 1.9385 13.3023C2.17818 13.7727 2.56063 14.1552 3.03104 14.3948C3.56582 14.6673 4.26588 14.6673 5.66602 14.6673Z"
    />
  </svg>
);
const IconEmailOutline = forwardRef((props: Omit<IconProps, 'icon'>, ref) => {
  return <Icon ref={ref} icon={Svg} {...props} />;
});
export default IconEmailOutline;
